import { Box, Button, MenuItem, TextField, useMediaQuery, useTheme } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useDeductionTypesList } from "api/hooks/humanResource";
import { useSelector } from "react-redux";
import { requester } from "api/pesabackend";

const DeductionTypeSchema = yup.object().shape({
  related_deduction_type: yup.string().required("required"),
  frequency: yup.string().required("required"),
  amount: yup.number().required("required"),
});



const EmployeeDeductionForm = (props) => {
  const pageType = props.formType;
  let { employeeId, editData } = props;
  const userId = useSelector((state) => state.authReducer.user.userId);
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const { palette } = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const isNew = pageType === "create";
  const isEdit = pageType === "edit";
  const {deductionTypeList} = useDeductionTypesList(1, business_branch_id);

  const initialValuesDeductionType = isNew ? {
    related_deduction_type: "",
    amount: 0,
    frequency: "",
  } : {
    related_deduction_type: editData.related_deduction_type.id,
    amount: editData.amount,
    frequency: editData.frequency,
  };

  const saveDeductionType = async (values, onSubmitProps) => {
    values.added_by = userId;
    values.related_employee = employeeId;

    const savedResponse = await requester.post( `/human_resource/employees/payroll?payroll_type=deduction`, JSON.stringify(values));
    
    if (savedResponse.data.status === 201) {
      onSubmitProps.resetForm();
      props.setIsSuccess(true);
      props.setNewEmployeeDeductionData(true);
      props.setOpen(false);
    }
  };

  const editDeductionType = async (values, onSubmitProps) => {
    const savedResponse = await requester.post(`/human_resource/employees/payroll/edit/${editData.id}`, JSON.stringify(values));
    
    if (savedResponse.data.status === 201) {
      onSubmitProps.resetForm();
      props.setIsSuccess(true);
      props.setNewEmployeeDeductionData(true);
      props.setOpen(false);
    }
  };

  const handleFormSubmit = async (values, onSubmitProps) => {
    if (isNew) await saveDeductionType(values, onSubmitProps);
    if (isEdit) await editDeductionType(values, onSubmitProps);
  };

  return (
    <Formik
      onSubmit={handleFormSubmit}
      initialValues={initialValuesDeductionType}
      validationSchema={DeductionTypeSchema}
    >
      {({
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
      isSubmitting,
      }) => (
        <form onSubmit={handleSubmit}>
          <Box
            display="grid"
            gap="30px"
            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            sx={{
              "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
            }}
          >
            <TextField
              label="Deduction Type"
              onBlur={handleBlur}
              select
              disabled={isEdit}
              onChange={handleChange}
              value={values.related_deduction_type}
              name="related_deduction_type"
              error={
                Boolean(touched.related_deduction_type) &&
                Boolean(errors.related_deduction_type)
              }
              helperText={
                touched.related_deduction_type && errors.related_deduction_type
              }
              sx={{ gridColumn: "span 2" }}
            >
              {deductionTypeList.map((row, index) => {
                return (
                  <MenuItem
                    key={index}
                    value={row.id}
                    selected={
                      row.id === values.related_deduction_type ? true : false
                    }
                  >
                    {row.deduction_name}
                  </MenuItem>
                );
              })}
            </TextField>

            <TextField
              label="Amount"
              onBlur={handleBlur}
              type="number"
              onChange={handleChange}
              value={values.amount}
              name="amount"
              error={Boolean(touched.amount) && Boolean(errors.amount)}
              helperText={touched.amount && errors.amount}
              sx={{ gridColumn: "span 2" }}
            />

            <TextField
              label="Frequency"
              onBlur={handleBlur}
              select
              defaultValue={"MONTHLY"}
              onChange={handleChange}
              value={values.frequency}
              name="frequency"
              error={Boolean(touched.frequency) && Boolean(errors.frequency)}
              helperText={touched.frequency && errors.frequency}
              sx={{ gridColumn: "span 2" }}
            >
              <MenuItem value="DAILY">DAILY</MenuItem>
              <MenuItem value="WEEKLY">WEEKLY</MenuItem>
              <MenuItem value="BI-WEEKLY">BI-WEEKLY</MenuItem>
              <MenuItem value="MONTHLY">MONTHLY</MenuItem>
              <MenuItem value="ANNUALLY">ANNUALLY</MenuItem>
            </TextField>
          </Box>

          {/* BUTTONS */}
          <Box>
            <Button
              fullWidth
              type="submit"
              disabled={isSubmitting}
              sx={{
                m: "1rem 0",
                p: "1rem",
                backgroundColor: palette.primary.main,
                color: palette.background.alt,
                "&:hover": { color: palette.primary.main },
              }}
            >
              Save
            </Button>
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default EmployeeDeductionForm;
